/* eslint-disable import/no-unresolved */
import React, { useState, useEffect, useContext } from 'react';
import { swalMessages } from '@auteco/constants';
import swal from 'sweetalert';
import billingService from '../../services/billingService';
import BillsPage from '../../pages/MaestrosPage/BillsPage/BillsPage';
import { Context } from '../../context/Contex';

const initialValues = {
  clase: '',
  signo: '',
  signo_neto: '',
  unidad_negocio_id: '',
};

const BillsContainer = () => {
  const { unidad, permisos } = useContext(Context);
  const [bills, setBills] = useState('');
  const [clase, setClass] = useState('');
  const [update, setUpdate] = useState(false);
  const [loading, setLoading] = useState({ loading: false, state: false });
  const [currency, setCurrency] = useState({ ...initialValues, unidad_negocio_id: unidad });

  const getBills = () => {
    billingService.getBilling(unidad)
      .then((response) => {
        setBills(response.data.datos);
        setLoading(false);
      })
      .catch((erorr) => {
        console.log(erorr);
      });
  };

  const getClassBilling = () => {
    billingService.getClasses()
      .then((response) => {
        setClass(response.data.datos);
        setLoading(false);
      })
      .catch((erorr) => {
        console.log(erorr);
      });
  };

  const handleCreate = (event) => {
    event.preventDefault();
    setLoading({ state: true, loading: false });
    if (!update) {
      billingService.postBilling(currency)
        .then(() => {
          getBills();
          setCurrency({ ...initialValues, unidad_negocio_id: unidad });
        })
        .catch((erorr) => {
          console.log(erorr);
        });
    } if (update) {
      billingService.putBilling(currency)
        .then(() => {
          setCurrency({ ...initialValues, unidad_negocio_id: unidad });
          setUpdate(false);
          setLoading(false);
          getBills();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleDelete = (value) => {
    const found = bills.find((element) => element.UUID === value);
    swal(swalMessages.DELETE_CONFIRM)
      .then((willDelete) => {
        if (willDelete) {
          billingService.deleteBilling(found)
            .then(() => {
              getBills();
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
  };

  const handleUpdate = (value) => {
    const found = bills.find((element) => element.UUID === value);
    if (found) {
      setUpdate(true);
      setCurrency({
        ...currency,
        clase: found.CLASE,
        signo: found.SIGNO,
        signo_neto: found.SIGNO_NETO,
        unidad_negocio_id: unidad,
        id: found.UUID,
      });
    }
  };

  const handleChange = (event, type) => {
    setCurrency({ ...currency, [type]: event.target.value });
  };

  useEffect(() => {
    setLoading({ loading: true });
    getBills();
    getClassBilling();
  }, []);

  return (
    <>
      <BillsPage
        permisos={permisos}
        loading={loading}
        update={update}
        unidad={unidad}
        bills={bills}
        clase={clase}
        currency={currency}
        setUpdate={setUpdate}
        onChange={handleChange}
        onSubmit={handleCreate}
        onDelete={handleDelete}
        onUpdate={handleUpdate}
      />
    </>
  );
};

export default BillsContainer;
